import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export function isWithinLength(maxLength: number, message?: string): ValidatorFn {
  const validationError = message ? { maxLength: message } : { error: true }

  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value.length > maxLength) {
      return validationError
    }

    return null
  }
}
